import { LoadingOverlay } from '@mantine/core'
import { useScrollLock } from '@mantine/hooks'
import { useRouter } from 'next/router'
import { useEffect } from 'react'
import Lottie from 'react-lottie'

import animationData from '../../public/img/lottie/loading.json'
import styles from './Loading.module.scss'

interface ILoadingProps {
  loadingText?: string
}

const Loading = ({ loadingText }: ILoadingProps) => {
  const [scrollLocked, setScrollLocked] = useScrollLock()

  useEffect(() => {
    return () => {
      window.document.body.style.overflow = 'visible'
      setScrollLocked(false)
    }
  }, [])

  return (
    <LoadingOverlay
      loader={
        <div className={`${styles.LoadingContainer}`}>
          <Lottie
            options={{
              loop: true,
              autoplay: true,
              animationData,
            }}
          />
          {loadingText && <p className="mt-2 text-lg font-medium">{loadingText}</p>}
        </div>
      }
      visible={true}
      overlayOpacity={0.55}
      overlayColor="#ffffff"
      className={styles.LoadingOverlay}
    />
  )
}

export default Loading
